
import VideoTick from "../../../assets/outline/VideoTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoTickIcon({ className, dataTestid = "VideoTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
